<template>
  <div >
    <!-- <h1>我的聊天应用</h1> -->
    <!-- 左侧 -->
    <div class="panel">
      <div class="left">
        <a-button class="lbtn" icon="plus" type="primary" @click="onNew">&nbsp&nbsp&nbsp新对话
        </a-button>
        <!-- @input="handleScroll"  contenteditable="true"  -->
        <div class = "textTitle" style="">历史生成记录</div>
        <div class = "lists" v-infinite-scroll="handleScroll"
            :infinite-scroll-disabled="loading"
            :infinite-scroll-distance="10">
          <div v-for="(list,i) in lists" >
            <span style="color:rgba(0, 0, 0, 0.40);font-size: 12px;margin-left: 20px;margin-top: 20px;">{{ list.title }}</span>
            <div v-for="(l,ii) in list.l" >
              <div class="list" @click="onPick(i,ii,l.conversation)" @mouseenter="onMsgEnter(i,ii)" @mouseleave="onMsgOut" :class="(i==index&&iindex==ii) ?'slist':''">
                <a-icon style='margin-left: 10px;' type="container" />
                <!-- <span>{{ l}}</span> -->
                <!-- :disabled="i==index&&iindex==ii?false:true" -->
                <!-- <div v-if="i==index&&iindex==ii&&eiindex==ii?false:true" @click="onPick(i,ii)" style=" z-index:100;position: absolute; border: 1px solid rgba(22,33,21,1);width: 240px;height:48px;margin-left: 0px;"></div> -->
                <a-input :maxLength="iMLen" v-if="i==index&&iindex==ii&&eiindex==ii" :ref="'ainput'+i+'_'+ii" :disabled="i==index&&iindex==ii&&eiindex==ii?false:true" style="width: 220px;text-decoration:underline" v-model="input[i][ii]" placeholder="" ></a-input>
                <div class="input-text" v-else>{{l.sessionName}}</div>
                <!-- <div  style="border: 2px solid rgba(22,33,21,1);width: 260px;height:48px;margin-left: -240px;"></div> -->
                <template v-if="i==index&&iindex==ii&&eiindex!=ii">
                  <a-button @mouseenter="onMsgIconEnter(i,ii,0)"  @click.stop="onEdit(i,ii,ii)" @mouseleave="onIconMsgOut" icon="edit" 
                  size="small" :class="i==index&&ii==iindex&&emindex==0?'icon-btn1':'icon-btn2'"> </a-button>
                  <!-- <div class="icon" @mouseenter="onMsgEnter(index)" @mouseleave="onMsgOut" :class="iindex==index ?'slist':''"><a-icon type="edit" /></div> -->

                  <a-popconfirm
                    title="确认删除记录?"
                    ok-text="确认"
                    cancel-text="取消"
                    @confirm="onDelOk(i,ii,ii,l.conversation)"
                    @cancel="onDelCancle"
                  >
                  <a-button @mouseenter="onMsgIconEnter(i,ii,1)"  @click.stop="onDelete(i,ii,ii)" @mouseleave="onIconMsgOut" icon="delete" 
                  size="small" :class="i==index&&ii==iindex&&emindex==1?'icon-btn1':'icon-btn2'"> </a-button>
                  </a-popconfirm>
              
                  <!-- <div class="icon"><a-icon type="delete" /></div> -->
                </template >
                <template v-if="i==index&&iindex==ii&&eiindex==ii">
                  <a-button @mouseenter="onMsgIconEnter(i,ii,2)"  @click.stop="onEditOk(i,ii,ii,l.conversation)" @mouseleave="onIconMsgOut" icon="check" 
                  size="small" :class="i==index&&ii==iindex&&emindex==2?'icon-btn1':'icon-btn2'"> </a-button>
                  <a-button @mouseenter="onMsgIconEnter(i,ii,3)"  @click.stop="onEditCancel(i,ii,ii)" @mouseleave="onIconMsgOut" icon="close" 
                  size="small" :class="i==index&&ii==iindex&&emindex==3?'icon-btn1':'icon-btn2'"> </a-button>

                  <!-- <div class="icon"><a-icon type="check" /></div>
                  <div class="icon"><a-icon type="close" /></div> -->
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <a-divider style="height: 766px;margin-left: 10px;width:1px" type="vertical" />
      </div>
     
      <ChatWindow :onEnd='onEnd' ref="chatref"/>
    </div>
  </div>
 
</template>

<script>
import toNumber from 'lodash/toNumber';
import ChatWindow from './ai.vue';
import { aiapi } from './aiapi';
export default {
  components: {
    ChatWindow,
  },
  data() {
    return {
      lists:[{title:'今天',l:[{conversation:11,sessionName:'fff'},{conversation:11,sessionName:'fff'}]},
              {title:'后台天',l:[{conversation:11,sessionName:'fff'}]},
              {title:'后台天',l:[{conversation:11,sessionName:'fff'}]},
              {title:'后台天',l:[{conversation:11,sessionName:'fff'}]},
            ],
      iMLen :20,      
      input:[['新对话2','新对话1','新对话1','新对话1'],['新对话3','新对话4'],['新对话3','新对话4'],['新对话3','新对话4'],['新对话3','新对话4']['新对话3','新对话4']],
      index:-1,//大外面index
      iindex:-1,//鼠标滑动选择index
      emindex:-1,//鼠标滑动icon index
      eiindex:-1,// 编辑index
      loading:false,
      nextDataId:0,//下一条服务端记录
      hasMore:true
    }
  },
  mounted() {
    this.getData();
    //this.watchSize();
    //sse.fetchsse();
  },
  methods: {
    onEnd(){
      this.getData();
    },
    //获取年月日
    transDate(n) {
      var date = new Date(toNumber(n));
      //console.log(n)
     // console.log(date)
      var Y = date.getFullYear() + '-';
      var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
      var D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();

      return (Y + M + D)
    },

    async getData(){
      //console.log("getData")
      let data= await aiapi.getHistoryList({
          nextDataId: this.nextDataId,
        });
        this.nextDataId = data.nextDataId;
        this.hasMore = data.hasMore;
        let list = data.list;
        //console.log(list)
        let l = {}
        for(let ls in list){
          let date = this.transDate(list[ls].createdAt)
          //console.log(date)
          l[date] = l[date]?l[date]:[];
          let dd = {}
          dd.sessionName = list[ls].sessionName;
          dd.conversation = list[ls].conversation;
          l[date].push(dd);
        }
        //console.log(l)
        this.lists=[]  
        this.input=[]
        for(let d in l){
          let dd = {};
          dd.title = d;
          let ddd=l[d];
          dd.l = ddd
          this.lists.push(dd);
          let dddd=[]
          for(let s in ddd){
            dddd.push(ddd[s].sessionName)
          }
          this.input.push(dddd);
        }
        //console.log(this.lists)
        //console.log(this.input)
        // l['']
        // let d1 = new Date("2023-08-10").getTime()
        // let d2 = new Date("2023-08-11").getTime()
        // let d3 = new Date("2023-08-23 18:00:00").getTime()
        // let d4 = new Date().getTime()

        // let t = [];


    },
    onMsgEnter(index,iindex){
      //console.log("onMsgEnter")
      this.index = index;
      this.iindex = iindex;
    },
    onMsgOut(){
      //console.log("onMsgOut")
      // this.index = -1;
      // this.iindex = -1;
    },
    onMsgIconEnter(index,iindex,emindex){
     // console.log("onMsgEnter")
      this.index = index;
      this.iindex = iindex;
      this.emindex = emindex;
    },
    onIconMsgOut(){
      //console.log("onMsgOut")
      this.emindex = -1;
    },
    onEdit(index,iindex,eiindex){
      this.index = index;
      this.iindex = iindex;
      this.eiindex = eiindex;
      //console.log( this.$refs)
     // console.log(this.$refs['ainput'+index+'_'+iindex])
      this.$nextTick(function() {
        this.$refs['ainput'+index+'_'+iindex][0].focus()
      });

      // this.$nextTick(()=>{
      //   //this.$refs.saveTagInput.$refs.input.focus();
      //   this.$refs['ainput'+index+'_'+iindex].$refs['ainput'+index+'_'+iindex].focus()
      //       //this.$refs.ainput.focus()
      //   })
      // this.$refs.ainput.focus()
      
    },
     onDelete(index,iindex,eiindex){
      this.index = index;
      this.iindex = iindex;
      this.eiindex = -2;
     
    },
    //删除记录
    async onDelOk(index,iindex,eiindex,id){
      let data= await aiapi.deleteHistory({
        conversation: id,
        });
        //this.getData();
        this.eiindex =-1
        this.input[index].splice(iindex, 1);
        // this.input[index][iindex] = data.conversationName;

        this.lists[index].l.splice(iindex, 1);//[iindex];//.sessionName =data.conversationName
        this.$message.info("删除成功");
    },
    onDelCancle(){
      this.eiindex =-1
    },
    //更改标题
    async onEditOk(index,iindex,eiindex,id){
      let msg = this.input[index][iindex];
      this.index = index;
      this.iindex = iindex;
      this.eiindex = eiindex;
      let data= await aiapi.updateTitle({
        conversation: id,
        newName:msg
        });
        this.input[index][iindex] = data.conversationName;
        this.lists[index].l[iindex].sessionName =data.conversationName
        this.eiindex = -1;
        this.$message.info("更改成功");
    },
    onEditCancel(index,iindex,eiindex){
      let msg = this.input[index][iindex];
      this.index = index;
      this.iindex = iindex;
      this.eiindex = -1;
    },
    async onPick(index,iindex,id){
      //console.log("onPick")
      if(this.index == index&&this.iindex == iindex&& (this.eiindex ==iindex||this.eiindex ==-2)){
        return;
      }
      //console.log("onPick1")
      //console.log(id)
      //todo 历史显示
      let data= await aiapi.getHistory({
        conversation: id,
        });
        //console.log(data)
        //console.log(data.list)
        if(data&&data.list){
          this.$refs.chatref.initHistory(id,data.list)
        }
    },
    onNew(){
      this.$refs.chatref.clearMsg()
    },
    handleScroll(){
      //console.log("handleScroll")
      if(this.hasMore){

      }
    }
  }
};
</script>
<style scoped lang="scss">
.panel{
  display: flex;
  flex-direction: row;
  background-color: #fff;
  min-width: 1200px;
  padding: 24px;
  // border: 2px solid rgba(240, 242, 245, 1);
  .left{
    *::-webkit-scrollbar {
      display: none;
    }
    * {
      -ms-overflow-style: none;
    }
    * {
      scrollbar-width: none;
    }
      ::-webkit-scrollbar {
        display: none;
      }
      ::inner {
        overflow: auto;
      }
      ::-webkit-scrollbar {
        width: 0 !important;
      }
      width:320px;
      height:766px;
      // border: 2px solid rgba(240, 242, 245, 1);
      border-radius: 6px;
      //height: 700px;
        //overflow:scroll;
      .lbtn{
        width:300px;height:40px;margin-left: 8px;margin-top: 20px;
        background-color: rgba(119, 137, 255, 1);
        margin-bottom: 20px;
      }
      .textTitle{
        color: rgba(57, 57, 57, 1);
        font-size: 14px;
        font-weight: bold;
        //margin-top: 20px;
        margin-left: 20px;
        margin-bottom: 20px;
        // margin-bottom: 20px;
        // padding-bottom: 20px;
      }
      .lists{
        height: 650px;
        // overflow:scroll;
        overflow-y: scroll;   
        scrollbar-width: none;
        -ms-overflow-style: none;
        z-index:1001;
      }
      .slist{
        background-color:rgba(240, 242, 245, 1);
      }
      .list{
        color:rgba(57, 57, 57, 1);
        font-size: 14px;
        margin-top: 4px;
        margin-bottom: 4px;
        margin-left: 10px;
        border: 4px;
        width: 300px;
        height: 48px;
        text-align: left;
  
        display: flex;
        flex-direction: row;
        align-items: center;
        // justify-content: left;
        //text-align: left;
        // float: left;
        // padding: 8px;
        .input-text{
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          padding-left: 11px;
          width:220px
        }
        .icon-btn1{
          background-color:rgba(0, 0, 0, 0.05);
          border: none;
          color: black;
          size:small;
        }
        .icon-btn2{
          background-color: rgba(0, 0, 0, 0);
          border: none;
          size:small;
        }
        .ant-input{
          resize: none; 
          border: none; 
          background-color: rgba(119, 137, 255, 0);
        }
        .ant-input:focus {
          border: none;
          box-shadow: none;
          cursor:pointer;
        }
        .ant-input[disabled] {
          color: rgba(0, 0, 0, 0.6);
          // background-color: #f9f9f9;
          cursor:auto;
        }
        
        .ant-select-disabled {
          color: rgba(0, 0, 0, 0.6);
        }
        .ant-select-disabled .ant-select-selection {
          background: #f9f9f9;
          cursor: none;//not-allowed;
        }
      }
      
    }
}

</style>